import React, { useState } from "react";
import SignupForm from "../components/SignupForm";
import LoginForm from "../components/LoginForm";
import { useNavigate } from "react-router";

import img1 from '../assets/registerImg1.png'
import img2 from '../assets/registerImg2.png'
import LandingPageNavbar from "../components/LandingPageNavbar";

const Register = () => {
  const [flag, setFlag] = useState(false);
  // const navigate = useNavigate();

  return (
    <div style={{height: '80vh'}}>
      <LandingPageNavbar/>
      <div className="registerPage">
        {!flag ? <img src={img1}/> : <img src={img2}/>}
        <div className="inputWrapper">
          {!flag ? <h1>Signup</h1> : <h1>Login</h1>}
          {!flag ? <SignupForm /> : <LoginForm />}
          {!flag ? (
            <p onClick={() => setFlag(!flag)} style={{ cursor: "pointer", fontSize: '2rem' }}>
              Already have an Account. <span style={{color: '#fe4e00'}}>Click here to Login.</span>
            </p>
          ) : (
            <p onClick={() => setFlag(!flag)} style={{ cursor: "pointer", fontSize: '2rem' }}>
              Don't have an account? <span style={{color: '#fe4e00'}}>Click here to Signup.</span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Register;
